import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { RenderDirective } from '@core/prosemirror-legacy/angular';
import {
  ProsemirrorBasicConfig,
  ProsemirrorBasicConfigDirective,
} from '@core/prosemirror-legacy/webapp';
import { type AnySymbol, SymbolComponent } from '@core/symbol-legacy';
import { HeadingComponent } from '@core/user-interface-legacy';

export interface AskTemplateCardData {
  name: string;
  symbol: AnySymbol | null;
  descriptionJson: object | null;
}

@Component({
  selector: 'ask-template-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HeadingComponent, SymbolComponent, ProsemirrorBasicConfigDirective, RenderDirective],
  template: `
    <div layout layout-align-items-center>
      @if (askTemplate().symbol; as symbol) {
        <rt-symbol [symbol]="symbol" margin-right-small-x />
      }
      <rt-heading variant="heading large">
        {{ askTemplate().name }}
      </rt-heading>
    </div>
    <div
      class="description"
      prosemirrorBasicConfig
      [prosemirrorRender]="askTemplate().descriptionJson"
      [prosemirrorRenderConfig]="ProsemirrorBasicConfig"
    ></div>
  `,
  styleUrl: './ask-template-card.component.less',
  host: {
    class: 'rt-card',
  },
})
export class AskTemplateCardComponent {
  protected readonly ProsemirrorBasicConfig = ProsemirrorBasicConfig;

  public askTemplate = input.required<AskTemplateCardData>();
}
